import lozad from 'lozad';

export default {
	init() {

		var container = document.getElementsByClassName('archiveTrade');

		if( container.length != 0 ) {

			var main = document.querySelector('main');
			var mainStyle;

			function FilterActionInput() {

				var filter = container[0].querySelectorAll('.filter--input input');

				Array.prototype.forEach.call(filter, function(element,id) {

					element.addEventListener('focus' , (event) => {

						element.parentNode.querySelectorAll('label')[0].classList.add('goTop');

					});

					element.addEventListener('blur' , (event) => {

						if( !event.target.value ) {

							element.parentNode.querySelectorAll('label')[0].classList.remove('goTop');

						} 						

					});

				});

			}

			function FilterActionSelect() {

				var filter = container[0].querySelectorAll('.filter--select');
				var values;
				var selectValues;

				filter.forEach( function(element, index){		

					element.addEventListener('click',function(event){

						event.stopPropagation();

						filter.forEach( function( element2 , index2 ) {

							if( index == index2 ) {

								if( element2.classList.contains('active') ) {

									element2.classList.remove('active');

								} else {

									element2.classList.add('active');

								}
 
							} else {

								element2.classList.remove('active');

							}

						});

					});

					element.querySelectorAll('li').forEach( function( li, indexLi ) {

						li.addEventListener('click',function(eventLi){

							eventLi.stopPropagation();

							element.querySelector('input').value = li.textContent;
							element.classList.remove('active');

							element.querySelectorAll('li').forEach( function( li2, indexLi2 ){

								if( indexLi == indexLi2 ) {

									li.classList.add('hide');

								} else {

									li2.classList.remove('hide');

								}

							});

						});

					});

				});

				document.addEventListener('click', function() {

					filter.forEach( function(element, index){

						if( element.classList.contains('active') ) {

							element.classList.remove('active');

						}

					});

				});

			}

			function FilterSubmit() {

				var submit = document.querySelector('.filters__submit');
				var filterSort = document.querySelector('.filter--sort');

				var filters = document.querySelectorAll('.filter__value');

				var main = document.querySelector('main');

				function Filter() {

					var selfURL = document.querySelector('main').getAttribute('data-url');
					var carsContainer = document.querySelector('.cars__list');			
					var args = '?js=yes';

					filters.forEach( function(el,index) {

						if( el.value && el.value !='Wszystkie') {

							if( index <= filters.length ) {

								args += '&';

							}

							args += el.getAttribute('name')+'='+ el.value 
						}

					});
			
					selfURL += args;

					setTimeout(

						function(){

							var req = new XMLHttpRequest();

							req.onreadystatechange = function(){

								if ( req.readyState==4 && req.status==200 ) {

									if( carsContainer && carsContainer.length != 0 ) {

										carsContainer.remove();

									}

									document.querySelector('.cars__sorting').insertAdjacentHTML('afterend', req.responseText);				

									ScrollTo();

									main.classList.remove('load');
								}

							}

							req.open('GET', selfURL, false); 
							req.setRequestHeader("Content-type", "text/json");
							req.send();

							var pictureObserverAfterLoadDOM = lozad('.lazy-load-item', {
				    			threshold: 0,
				    			loaded: function(el) {
				                    el.classList.add('asset-loaded');
				                }
							});
							pictureObserverAfterLoadDOM.observe();

						},500

					);

					var argsChange = args.replace('js=yes&','');
					argsChange = argsChange.replace('js=yes','');
					console.log(argsChange);
					history.pushState(null,null,argsChange );

				}

				submit.addEventListener('click' , function(){

					main.classList.add('load');
					Filter();

				});

				filterSort.querySelectorAll('li').forEach( function( element , index ) {

					element.addEventListener('click' , function(){

						main.classList.add('load');
						Filter();

					});

				});

			}

			function ScrollTo () {

				var container = document.querySelector('.cars__list');
				mainStyle = getComputedStyle(main);

				window.scrollTo({
					top: (container.offsetTop - parseInt(mainStyle.paddingTop ) ),
					left: 0,
					behavior: 'smooth',

				});

			}

			FilterActionInput();
			FilterActionSelect();
			FilterSubmit();

			if( window.location.href.search('strona=') != -1 ) {

				ScrollTo();

			}
			

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
